import { jsx as _jsx } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import AuthHelper from './auth-helper';
export const AuthComponent = ({ audience = '', clientId, children, connection, domain, redirectUri = window.location.origin, }) => {
    const history = useHistory();
    const onRedirectCallback = (appState) => {
        history.push(appState && appState.returnTo ? appState.returnTo : window.location.pathname);
    };
    return (_jsx(Auth0Provider, { authorizationParams: {
            audience,
            connection,
            redirect_uri: redirectUri,
        }, clientId: clientId, domain: domain, onRedirectCallback: onRedirectCallback, useRefreshTokens: true, useRefreshTokensFallback: true, children: _jsx(AuthHelper, { children: children }) }));
};
export default AuthComponent;
//# sourceMappingURL=auth.js.map